// extracted by mini-css-extract-plugin
module.exports = {"article-meta":"ArticleMeta_article-meta___Skzg","dot":"ArticleMeta_dot__E83Dd"};